package amazon.lastmile.inject

import app.nestbridge.domain.identity.service.DefaultProfessionalProfileService
import app.nestbridge.domain.identity.service.ProfessionalProfileService
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultProfessionalProfileService::class)
public interface AppNestbridgeDomainIdentityServiceDefaultProfessionalProfileService {
  @Provides
  public fun provideDefaultProfessionalProfileServiceProfessionalProfileService(defaultProfessionalProfileService: DefaultProfessionalProfileService): ProfessionalProfileService = defaultProfessionalProfileService
}
